const locale = {
  THEME: {
    CHINESE: '中文',
    DOCUMENTATION: '文档',
    CHINESE_SIMPLE: '简体中文',
    BANNER_TEXT: '可用的 EnOS 功能取决于 License 和账号权限。如果某些功能在你的环境中不可用，可咨询系统管理员。',
    PRIVACY_POLICY: '隐私声明',
    USER_AGREEMENT: '用户协议',
    GLOBAL_SEARCH_PLACEHOLDER: '在全局内搜索'
  },
  preview: {
    BANNER_TEXT: '该预览内容已停止更新，部分信息可能过时。如需查看最新产品文档，请访问 3.1.0 文档。'
  }
};

export default locale;
